export function scrollToSubscribe(navigate: (to: string) => void) {
  const target = document.getElementById("subscribe");
  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
  navigate("/");
  window.setTimeout(() => {
    document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 450);
}